import { useMemo } from 'react';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId } from '~/modules';
import { useCommodityDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { CommodityDetailHeader } from './CommodityDetailHeader/CommodityDetailHeader';

export const CommodityDetail = () => {
  const { commodityId } = useCommodityDetail();
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.commodityDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.COMMODITY, entityId: commodityId }),
    [commodityId],
  );

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={<CommodityDetailHeader id={commodityId} tabs={tabs} />}
          modules={
            <ModuleContextProvider value={contextValue}>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </ModuleContextProvider>
          }
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
